import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { C } from '../theme';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Caught error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{
          minHeight: '100vh',
          background: C.bgApp,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '32px 24px',
          textAlign: 'center',
          gap: '16px',
        }}>
          <img src="/logo.png" alt="binko" style={{ height: '44px', width: 'auto', marginBottom: '8px' }} />
          <Typography sx={{ fontSize: '24px' }}>⚠️</Typography>
          <Typography sx={{ fontSize: '18px', fontWeight: 600, color: C.textPrimary }}>
            Something went wrong
          </Typography>
          <Typography sx={{ fontSize: '14px', color: C.textMuted, lineHeight: 1.6, maxWidth: '300px' }}>
            Please refresh the page. If this keeps happening, contact support.
          </Typography>
          <Button
            onClick={() => window.location.reload()}
            sx={{
              mt: '8px',
              border: `0.5px solid rgba(255,255,255,0.15)`,
              color: C.textMuted,
              borderRadius: '10px',
              padding: '8px 20px',
              fontSize: '13px',
              '&:hover': { background: 'rgba(255,255,255,0.05)' },
            }}
          >
            Refresh
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
